import '@angular/localize/init';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

declare global {
  interface Window {
    __cookieConsentConfig?: {
      enabled?: boolean;
      domainScriptId?: string;
      scriptUrl?: string;
    };
  }
}

window.__cookieConsentConfig = {
  enabled: environment.cookieConsent.enabled,
  domainScriptId: environment.cookieConsent.domainScriptId,
  scriptUrl: environment.cookieConsent.scriptUrl
};

if (environment.applicationInsights.enabled && environment.applicationInsights.connectionString) {
  const applicationInsights = new ApplicationInsights({
    config: {
      connectionString: environment.applicationInsights.connectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      correlationHeaderExcludedDomains: ['cdn.cookielaw.org', 'geolocation.onetrust.com'],
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true
    }
  });

  applicationInsights.loadAppInsights();
  applicationInsights.trackPageView();
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
